window.CESIUM_BASE_URL = '/';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as echarts from 'echarts'
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
import '@/assets/css/common.scss'

import global from './components/global'
import common from './components/common'
import mapBase from './assets/map_base';
import mapWeather from './assets/map_weather';
import waterMark from './assets/watermark';
import mapOperator from './assets/map_operator';
import mapHeatLine from './assets/heatline';
import JsonExcel from 'vue-json-excel';

// ----------------------------
import crypto from './assets/js/crypto'

import './Utils/drag';

import './permission'

Vue.component('ExportExcel', JsonExcel);


axios.defaults.withCredentials = true;
axios.interceptors.request.use(
    config => {
        config.withCredentials = true;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

Vue.use(ElementUI)
Vue.prototype.$echarts=echarts

window.global = global;
Vue.prototype.global = global

window.axios = axios;
axios.defaults.withCredentials=true


window.common = common;
Vue.prototype.common = common

window.waterMark = waterMark;
Vue.prototype.waterMark = waterMark

window.mapBase = mapBase;
Vue.prototype.mapBase = mapBase

window.mapOperator = mapOperator;
Vue.prototype.mapOperator = mapOperator

window.mapWeather = mapWeather;
Vue.prototype.mapWeather = mapWeather

window.mapHeatLine = mapHeatLine;
Vue.prototype.mapHeatLine = mapHeatLine

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$crypto = crypto;

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')